import React from 'react'; 
import {Row, Col, Label, Button, Panel, Modal} from 'react-bootstrap';
import {injectIntl} from 'react-intl';
import BlockForm from './BlockForm';
import {inject, observer} from 'mobx-react';
import {BMC_BLOCKS} from '../common_components/bmc/bmc_constants';
import ImageAttachments from './ImageAttachments';


@injectIntl @inject("rootStore") @observer
export default class BlockSpecifics extends React.Component{

  render(){
    const {intl} = this.props;
    let element;
    const card =  this.props.rootStore.activityStore.activityEdit.preselectedCard;
    if( card && card.preselected ){
      return(
        <Modal
          show={this.props.showModal}
          onHide={this.props.onHideModal}
          className="igbusiness"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
              {card && card.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="card-modal">
              <BmcCardDescription card={card} />
              <br />
              <BlockForm />
            </div>
          </Modal.Body>
          <Modal.Footer>
            {this.renderButtons(card)}   
          </Modal.Footer>
        </Modal>
      );
    }
    return null;
  }

  renderButtons(card){
    const {intl} = this.props;
    let closeMessage = intl.formatMessage({id: "close"});
    if( card.selected ){
      return(
        <div>
          {<AddRemoveButton card={card} onAddCard={this.props.onAddCard} onRemoveCard={this.props.onRemoveCard}/>}
          <Button bsStyle="primary" onClick={this.props.onHideModal}>{closeMessage}</Button>
        </div>
      );
    }
    else{
      return(
        <div>
          <Button bsStyle="default" onClick={this.props.onHideModal}>{closeMessage}</Button>
          {<AddRemoveButton card={card} onAddCard={this.props.onAddCard} onRemoveCard={this.props.onRemoveCard}/>}
        </div>
      );
    }
      
  }

}

function BmcCardDescription({card}){
  return(
    <div>
      <Label>{card.name}</Label>
      <div>{card.description}</div>
      <ImageAttachments attachments={card.attachments} />
    </div>
  );
}

@injectIntl @inject("rootStore") @observer
class AddRemoveButton extends React.Component{

  constructor(props){
    super(props);

    this.addCardToBlock = this.addCardToBlock.bind(this);
    this.removeCardFromBlock = this.removeCardFromBlock.bind(this);
  }

  render(){
    const {intl} = this.props;
    const card = this.props.card;
    const activityEdit = this.props.rootStore.activityStore.activityEdit
    let saveMessage = intl.formatMessage({id: "add"});
    const block = this.props.rootStore.igBusinessStore.currentBlock;
    
    if( block == BMC_BLOCKS.KEY_ACTIVITIES ){
      saveMessage = intl.formatMessage({id: "save_continue"});
    }
    let element = 
        <Button bsStyle="primary" onClick={() =>{ this.addCardToBlock(card);}}>
          {saveMessage}
        </Button>;
    if( activityEdit.isSelected(card) ){
      element = 
        <Button bsStyle="default" onClick={() => { this.removeCardFromBlock(card)}}>
          {intl.formatMessage({id: "remove"})}
        </Button>;
    }
    return element;
  }

  addCardToBlock(card){
    this.props.onAddCard(card);
  }

  removeCardFromBlock(card){
    this.props.onRemoveCard(card); 
  }

}
